import axios from 'axios'
import React, { Component }  from 'react';
import history from '../route/history'
import CloudFlyerAPI from './CloudFlyerAPI'
import { Modal } from 'antd'

let login_warning = null

let error_warning = null

// export const http = axios.create({ baseURL: window.API })
export const http = axios.create({ baseURL: window.NEW_API })

http.interceptors.request.use(
  config => {
    if (
      // config.url.includes(window.API) ||
      // config.url.includes(window.ANALYTICS_API)
      config.url.includes(window.NEW_API) ||
      config.url.includes(window.NEW_ANALYTICS_API)
    ) 
    {
      config.headers['Authorization'] = "Bearer "+localStorage.Authorization;

      // if (config.url.includes('/billing') || config.url.includes('/hybrik')) {
      //   delete config.headers.common['Accept']
      // }
      // if (!config.url.includes(window.FTX_HOST))
      //   config.headers.common['Authorization'] = localStorage.Authorization
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)


http.interceptors.response.use(
  response => {
    return response
  },
  error => {
    
    if(error && error.response && error.response.status == 400){

      const errors = error.response.data.errors

      const errData = error.response.data

      console.log(error.response.data)
      let errorMsg = ""
      let newErrorMessage = ""
      
      if(errors){
        Object.keys(errors).map(er => {

          errorMsg = errorMsg + '\n' + errors[er].join(", ")
          console.log(errors[er].join(", "))
  
        })
 
        newErrorMessage = errorMsg.split('\n').map(str => <p>{str}</p>)
      }
      else{
        newErrorMessage = errData
      }

      error_warning = Modal.error({
        title: 'Error',
        content: newErrorMessage,
        okText: 'Close',
        onOk() {},
      })

      
    }


    if (error && error.response && 401 === error.response.status) {
      console.log('401 redirect to login')

      if (
        login_warning ||
        window.location.pathname.includes('login') ||
        window.location.pathname.includes('sharing') ||
        window.location.pathname.includes('desktop')
      )
        return
      login_warning = Modal.warning({
        title: 'Please sign in again',
        content: 'You were signed out of your account.',
        okText: 'Sign in',
        onOk() {
          login_warning.destroy()
          login_warning = null
          setTimeout(() => {
            CloudFlyerAPI.user_account.logout()

            if (window.appHistory) {
              window.appHistory.push(
                `/login?returnUrl=${window.location.pathname}`
              )
              return window.appHistory.go()
            }

            history.push(`/login?returnUrl=${window.location.pathname}`)
            window.location.href = window.location.href
            setTimeout(() => {
              if (!window.location.pathname.includes('login')) {
                console.log('location.reload()')
                window.location.reload()
              } else {
                console.log('No location.reload()')
              }
            }, 2)
          }, 2)
        },
      })
    } 
    else {
      return Promise.reject(error)
    }
  }
)

export function requestData(type) {
  return { type: type }
}

export function receiveData(type, json) {
  return {
    type: type,
    data: json,
  }
}

export function receiveError(type, err, custom_message) {
  if (!err) err = 'Something went wrong. Please try again later.'


  err = err.response ? err.response : err

  // err = {
  //   data : {message : "test message"}
  // }


  let message = (err || {}).data
    ? (err || {}).data.message
      ? (err || {}).data.message
      : (err || {}).data.error
    : null

  if (
    (err || {}).data &&
    (err || {}).data.errors &&
    (err || {}).data.errors.base
  ) {
    message = (err || {}).data.errors.base[0]
  }

  message = message
    ? message
    : custom_message
    ? custom_message
    : 'Something went wrong. Please try again later.'

  return {
    type: type,
  }
}
